<template>
  <v-container>
    <!-- <v-document
      :model="shipment"
      :documentModel="nextDocumentModel"
      :bodyTemplate="nextBodyTemplate"
      :documentPortalId="portalId"
      :email="['georgefreed@gmail.com']"
      v-if="nextDocumentModel"
    ></v-document> -->
    <div class="letter-body" v-html="letterBody"></div>

    <v-dialog v-model="dialog" :width="padW" F:height="padH">
      <v-signature-pad
        v-if="dialog && !camera"
        v-model="padModel"
        :signatureLabel="signatureLabel"
        :backgroundImage="padBackgroundImage"
        :useLandscape="useLandscape"
        :objectName="objectName"
        :recordId="recordId"
        :portal="portalId"
        :filename="filename"
        :w="padW"
        :h="padH"
      ></v-signature-pad>
      <v-take-photo
        :objectName="objectName"
        :recordId="recordId"
        :portal="portalId"
        v-model="padModel"
        :filename="filename"
        photoName="car_photo"
        v-if="dialog && camera"
      >
      </v-take-photo>
    </v-dialog>
    <!-- <v-footer class="fixed text-center" padless> -->

    <!-- <v-col class="text-center" cols="12"> -->

    <v-toolbar v-if="!onDevice" flat class="footer">
      <div class="container-center">
        <v-btn class="ma-2" :loading="loading" @click="submit()" color="success">
          <v-icon class="ma-2">mdi-check</v-icon>

          Submit
        </v-btn>
      </div>

      <v-alert v-if="errorMessage !== '' && errorMessage" type="error">
        {{ errorMessage }}
      </v-alert>
    </v-toolbar>

    <!-- </v-col> -->
    <!-- </v-footer> -->
  </v-container>
</template>

<script>
import axios from "axios";
import * as fun from "../plugins/common";
export default {
  name: "CustomerLetter",
  components: {
    VSignaturePad: () => import("../components/SignaturePad.vue"),
    VDocument: () => import("../components/Document.vue")
  },
  props: {
    body: String,
    onDevice: Boolean,
    objName: String,
    recId: String,
    docName: String,
    close: Function
  },
  data() {
    return {
      sentLetterId: "",
      portal: "",
      portalId: "",
      letterBody: "",
      recordId: "",
      url: "",
      dialog: false,
      camera: false,
      signatureLabel: "",
      photoName: "",
      model: null,
      padModel: "",
      padBackgroundImage: "",
      padW: 0,
      padH: 0,
      useLandscape: false,
      loading: false,
      errorMessage: "",
      successMessage: "",
      notSigned: "",
      notFilled: false,
      sendForEversign: false,
      clientIp: null,
      documentName: "",
      objectName: "",
      nextId: "",
      nextDocumentModel: null,
      shipment: null,
      nextBodyTemplate: null,
      nextLetterAttachment: "",
      nextSubject: "",
      toEmail: "",
      company: ""
    };
  },
  mounted() {
    // console.log(this.$root.sendMail);
    // if (localStorage.getItem("pageHash") == window.location.hash) {
    //   return;
    // }
    if (!this.onDevice) {
      this.clientIp = this.getIpAddress();
      this.decryptId();
    } else {
      this.letterBody = this.body;
      this.documentName = this.docName;
    }

    var that = this;
    localStorage.setItem("pageHash", window.location.hash);
    window.addEventListener("hashchange", function() {
      // console.log(window.location.hash);
      // if (!that.onDevice) {
      var pageHash = localStorage.pageHash;
      if (window.location.hash != pageHash) {
        if (pageHash) {
          that.currentHash = window.location.hash.toString().replace("#/", "");
          that.showPad();
          window.location.hash = pageHash;
        }
      }
      // } else {
      //   that.showPad(window.location.hash.split("_")[1]);
      // }

      // if (pageHash.indexOf(this.currentHash) == -1) {

      // }
      // Perform action
      // [...]
    });
  },
  beforeDestroy() {},
  methods: {
    async getIpAddress() {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        this.clientIp = data.ip;
        console.log(this.clientIp);
      } catch (error) {
        console.error("Error fetching IP:", error);
      }
    },
    decryptId() {
      var msg = this.$parent.$router.currentRoute.params.id;
      this.decr = fun.decrypt(msg, this.passPhrase);
      var portalId = this.decr.split(":")[0];
      this.portal = "emover_" + portalId;
      this.portalId = "portal_" + portalId;
      this.sentLetterId = this.decr.split(":")[1];
      var data = {
        object_name: "sent_letters",
        qry: { _id: this.sentLetterId },
        portal_id: this.portal
      };
      axios.post(this.serverURL + "/get_letter_body", data).then(response => {
        this.url = window.location.href;
        var record = response.data;
        if (record.existing_file) {
          var fileUrl = fun.siteLocation() + "/user_images/" + record.existing_file;
          window.location.replace(fileUrl);
        }
        var body = record.body;
        this.sendForEversign = record.send_for_eversign;
        this.documentName = record.document_name;
        this.objectName = "shipment";
        this.nextLetterAttachment = record.next_document_path;
        this.toEmail = record.to_email;
        this.company = record.company;
        this.nextSubject = record.next_document_subject;
        this.recordId = record.shipment_id;
        if (body) {
          this.letterBody = body;
        } else {
          this.letterBody = "Letter not found";
        }
        if (record.shipment) {
          this.shipment = record.shipment;
          this.nextDocumentModel = record.next_letter;
          var decoded = fun.decodeHtml(record.next_letter.body);
          this.nextBodyTemplate = fun.replaceLetterFields(decoded);
        }
        // var key = this.currentHash.split("_")[0];
        this.filename = this.documentName.replace(" ", "_") + ".png";
      });
    },
    getInputs(html) {
      var inputs = document.getElementsByTagName("input");
      if (inputs.length) {
        inputs.forEach(i => {
          if (i.type == "text") {
            // console.log(i.value);
            if (!i.value) {
              this.notFilled = true;
              return;
            }

            html = html.replace(i.outerHTML, i.value);
          }
          if (i.type == "textarea") {
            // console.log(i.value);
            // if(!i.value){
            //   this.notFilled=true
            //   return
            // }
            html = html.replace(i.outerHTML, i.value);
          }
          if (i.type == "checkbox") {
            console.log("yes");
            if (i.checked) {
              html = html.replace(i.outerHTML, "Yes");
            } else {
              html.replace(i.outerHTML, "No");
            }
          }
          if (i.type == "radio") {
            if (i.checked) {
              html = html.replace(i.outerHTML, "Yes");
            } else {
              html = html.replace(i.outerHTML, "");
            }

            console.log(i.checked);
          }
        });
      }
      var textarea = document.getElementsByTagName("textarea");
      if (textarea.length) {
        textarea.forEach(i => {
          // console.log(i.value);
          html = html.replace(i.outerHTML, i.value);
        });
      }
      return html;
    },
    savePdf() {
      var that = this;
      var html = document.getElementsByClassName("letter-body")[0].innerHTML;
      html = this.getInputs(html);
      var data = {
        portal: this.portal || "portal_" + this.$root.portal_id,
        portal_id: this.portalId || "portal_" + this.$root.portal_id,
        object_name: this.objectName || this.objName,
        record_id: this.recordId || this.recId,
        filename: this.filename ? this.filename.replace(".png", "") : "letter",
        html: html,
        document_name: this.documentName,
        client_ip: this.clientIp,
        host: `${location.protocol}//${location.hostname}:${location.port}`,
        from_customer: true
      };
      this.loading = true;
      try {
        axios
          .post(this.serverURL + "/create_pdf", data)
          .then(response => {
            // console.log(response);
            if (this.onDevice) {
              this.close();
            } else {
              if (that.nextLetterAttachment && that.toEmail) {
                try {
                  that.sendNextLetter();
                  window.location.href = response.data;
                } catch (error) {
                  this.loading = false;
                  console.log(error);
                  window.location.href = response.data;
                }
              } else {
                window.location.href = response.data;
              }
            }

            // if (!this.$root.isMobile && !this.$root.isTablet) {

            // }
          })
          .catch(function(error) {
            alert("Please complete all steps");
          });
      } catch (error) {
        this.loading = false;
        alert("error occured");
      }
    },
    sendNextLetter() {
      var nextLetterBody = "Attached please find signed " + this.nextSubject;
      var attachments = {
        file_path: this.nextLetterAttachment,
        name: this.nextSubject.replaceAll(" ", "_") + ".pdf"
      };
      var mailData = {
        message: nextLetterBody,
        subject: this.nextSubject,
        email_to: this.toEmail,
        attachments: attachments,
        comp_id: this.company
      };
      axios
        .post(this.serverURL + "/send_email_emover", mailData, {
          withCredentials: true
        })
        .then(response => {
          this.loading = false;
          console.log(response.data);
        });
    },
    showPad() {
      this.dialog = true;
      this.camera = false;
      var key = this.currentHash.split("_")[0];
      this.imgId = this.currentHash.split("_")[1];
      this.filename = key + "_" + this.documentName.replace(" ", "_").replace(/[^a-zA-Z0-9_]/g, "") + ".png";
      switch (key) {
        case "init":
          this.padBackgroundImage = "";
          this.signatureLabel = "Initial above line";
          this.padH = 300;
          this.padW = 350;
          break;
        case "sign":
          this.padBackgroundImage = "";
          this.signatureLabel = "Sign above line";
          this.padH = 300;
          this.padW = 350;
          break;
        case "camera":
          this.camera = true;
          this.padH = 600;
          this.padW = 450;
          break;
        default:
          break;
      }
    },
    validateSign() {
      this.notSigned = "";
      var doc = document;
      if (this.onDevice) {
        doc = new DOMParser().parseFromString(this.letterBody, "text/html");
      }
      Array.from(doc.getElementsByTagName("img")).forEach(e => {
        if (e.src.includes("sign-here.png") || e.src.includes("init-here.png")) {
          this.notSigned = e.src.includes("sign-here.png") ? "nosign" : "noinit";
        }
      });
    },
    sendToEverSign() {
      axios.post(this.serverURL + "/get_eversign_key", { portal: this.portal }).then(response => {
        var key = response.data;
        var html = document.getElementsByClassName("letter-body")[0].innerHTML;
        html = this.getInputs(html);
        //create_document_on_eversign
        axios
          .post(this.serverURL + "/create_document_on_eversign", {
            body: html,
            EVERSIGN_API_KEY: key
          })
          .then(response => {
            console.log(response);
          });
      });
    },
    submit() {
      this.errorMessage = "";
      if (!this.sendForEversign) {
        this.validateSign();
        if (this.notSigned) {
          this.errorMessage =
            this.notSigned == "" ? "Please sign the document." : "Please put initial(s) to the document";
        } else {
          this.loading = true;
          this.savePdf();
        }
      } else {
        var html = document.getElementsByClassName("letter-body")[0].innerHTML;
        html = this.getInputs(html);
        if (this.notFilled) {
          this.errorMessage = "Please fill required fields";
          return;
        } else {
          this.sendToEverSign();
        }
      }
    }
  },
  watch: {
    padModel() {
      // console.log(this.padModel);
      var key = this.currentHash.split("_")[0];
      this.dialog = false;

      var lnk = document.getElementById(this.imgId);
      var img;
      if (this.onDevice) {
        var k = key == "init" ? "initial" : key;
        this.letterBody = this.letterBody.replaceAll(k + "-here.png", this.padModel);
        // var doc = new DOMParser().parseFromString(this.letterBody, "text/html");
        // img = lnk.querySelector("img");
        // img.setAttribute("src", this.padModel);
        // img.setAttribute("class", "pad-image");
        // this.letterBody = document.body.innerHTML;
        // this.dialog = false;
      } else {
        if (key != "camera") {
          img = document.createElement("img");
          img.setAttribute("src", this.padModel);
          img.setAttribute("class", "pad-image");
          lnk.parentNode.replaceChild(img, lnk);
        } else {
          var div = document.createElement("div");
          lnk.parentNode.replaceChild(div, lnk);
          this.padModel.forEach(im => {
            var img = document.createElement("img");
            img.setAttribute("src", im);
            img.setAttribute("class", "pad-image");
            img.setAttribute("style", "margin:10px");
            div.appendChild(img);
          });
        }
      }
    }
  }
};
</script>

<style lang="css">
.pad-image {
  max-width: 350px;
}
@media only screen and (min-width: 900px) {
  .footer {
    position: fixed;
    right: 40px;
    bottom: 40px;
  }
  .container-center {
    justify-content: center;
    display: flex;
    width: 100%;
  }
  .letter-body {
    background-color: #fff;
    border: 1px solid;
    padding: 10px;

    display: flex;
    justify-content: center;

    height: calc(100vh - 100px);
    overflow-y: auto;
    position: relative;
  }
}
@media only screen and (max-width: 450px) {
  .letter-body {
    width: 100%;
    overflow: auto;
  }
}
</style>
